import language from './modules/language'
import styles from './modules/styles'
import core from './modules/core'

import createPersistedState from 'vuex-persistedstate'
import createLogger from 'vuex/dist/logger'
import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const isDebug = process.env.NODE_ENV !== 'production'

let plugins = [createPersistedState({ key: 'chat' })]
if (isDebug) {
  plugins.push(createLogger())
}

export default new Vuex.Store({
  modules: {
    language,
    styles,
    core
  },
  strict: isDebug,
  plugins: plugins
})



// WEBPACK FOOTER //
// ./src/store/index.js